export const StationBehaviorType = {
	FirstAction: 'firstaction',
	OneApprove: 'oneapprove',
	AllApprove: 'allapprove',
} as const;

export type StationBehaviorType = (typeof StationBehaviorType)[keyof typeof StationBehaviorType];
